import moment from 'moment'

export default {
    methods: {
        getAllQueryParams() {
            const params = new URLSearchParams(window.location.search);

            return Array.from(params.keys()).reduce(
                (acc, val) => ({ ...acc, [val]: params.get(val) }),
                {}
            );
        },
        // Overlay URL params on a defaults object: a param missing from the URL
        // keeps its default instead of becoming undefined (which axios drops,
        // losing the filter and, for per_page, falling back to an unpaginated
        // API response).
        withQueryDefaults(defaults, query) {
            const merged = { ...defaults };

            Object.keys(defaults).forEach((key) => {
                if (query[key] !== undefined && query[key] !== null) {
                    merged[key] = query[key];
                }
            });

            return merged;
        },
        dateFormat(date, format){
            if(date){
                return moment(date).format(format)
            }
            return null;
        },
        showSuccessMsg(msg) {
            this.$swal.fire({
                position: 'top-right',
                icon: 'success',
                toast: true,
                title: msg,
                showConfirmButton: false,
                timer: 1500
            })
        },
        showFailMsg(msg, timer = null) {
            this.$swal.fire({
                position: 'top-right',
                icon: 'error',
                toast: true,
                title: msg,
                showConfirmButton: false,
                timer: timer ?? 1500
            })
        },
        sameHeight() {
            let left_length = window.$("#video_wrap").length;
            let left = 0

            if (left_length > 0) {
                left = document.getElementById('video_wrap').getBoundingClientRect().height;
                document.getElementById('chat_wrap').style.height=left + 'px';
            }
        },
        collapseArrow() {
            // let self = this;

            // window.$('.collapse_arrow span').click(function () {
            //     window.$('#wrapper').removeClass('right_menu_collapse');
            //     window.$('#wrapper').toggleClass('vertical_collpsed');
            //     window.$('.mobile_overlay').toggleClass('open');

            //     if (window.$('#wrapper').hasClass('vertical_collpsed')) {
            //         self.hideOtherNav('.left_nav_list > li', '.left_f_list');
            //         self.hideOtherNav('.left_nav_level2', '.left_f_list_level2');
            //         self.hideOtherNav('.left_nav_level3', '.left_f_list_level3');
            //     }

            //     setTimeout(() => {
            //         self.sameHeight ()
            //     }, 490);
            // });
        },
        getTicketListHeight(){
            let ticketSelectDiv = document.querySelector('.ticket_contact_list_details_page_wrap');
            let ticketFilter = document.querySelector('.ticket_contact_list_details_filter');
            if(ticketSelectDiv){
                let ticketSelectDivTop = ticketSelectDiv.getBoundingClientRect().top
                var windowHeight = window.innerHeight;
                let ticketSelectDivHeight = windowHeight - ticketSelectDivTop;


                ticketSelectDiv.style.height = ticketSelectDivHeight + 'px';
                if (ticketFilter) {
                    ticketFilter.style.height = ticketSelectDivHeight + 'px';
                }
            }
        },
        ticketScrollbar(){
            let self = this;
            setTimeout(() => {
                self.getTicketListHeight ()
            }, 500);
            window.addEventListener('resize', self.getTicketListHeight);
        },
        getTicketTableListHeight(){
            let tickeContactDiv = document.querySelector('.vlan_ticket_contact_list_page_wrap');
            if(tickeContactDiv){
                let tickeContactDivTop = tickeContactDiv.getBoundingClientRect().top
                var windowHeight = window.innerHeight;
                let tickeContactDivHeight = windowHeight - tickeContactDivTop;
                tickeContactDiv.style.height = tickeContactDivHeight + 'px';

                const hasPaginatination = tickeContactDiv.querySelector('.retail_pagination');

                if (!hasPaginatination) {
                    tickeContactDiv.classList.add('has_no_pagination');
                }
            }

        },
        ticketingTableScroll(){
            let self = this;
            setTimeout(() => {
                self.getTicketTableListHeight ()
            }, 500);
            window.addEventListener('resize', self.getTicketTableListHeight);
        },
        getEmailTicketListHeight () {
            let ticketSelectDiv = document.querySelector('.vlan_ticket_list_page_wrap');
            let ticketFilter = document.querySelector('.ticket_list_filter');
            let collapseTicket = document.querySelector('.collapse_ticket');
            if(ticketSelectDiv){
                let ticketSelectDivTop = ticketSelectDiv.getBoundingClientRect().top
                var windowHeight = window.innerHeight;
                let ticketSelectDivHeight = windowHeight - ticketSelectDivTop;


                ticketSelectDiv.style.height = ticketSelectDivHeight + 'px';
                if(ticketFilter){
                    ticketFilter.style.height = ticketSelectDivHeight + 'px';
                }

                // This runs on every reload of the list, so guard against
                // stacking a fresh click handler each time (an even number of
                // handlers cancels the toggle out entirely).
                if(collapseTicket && !collapseTicket.dataset.collapseBound){
                    collapseTicket.dataset.collapseBound = 'true';
                    collapseTicket.addEventListener('click' , () => {
                        collapseTicket.classList.toggle('active');
                        ticketSelectDiv.classList.toggle('no_right_filter')
                    })
                }
            }

        },
        ticketingEmailTableScroll(){
            let self = this;
            setTimeout(() => {
                self.getEmailTicketListHeight ()
            }, 1000);
            window.addEventListener('resize', self.getEmailTicketListHeight);
        },
        getEmailTicketDetailsListHeight () {
            let ticketSelectDiv = document.querySelector('.vlan_ticket_list_page_wrap');
            let ticketFilter = document.querySelector('.ticket_list_filter');
            if(ticketSelectDiv){
                let ticketSelectDivTop = ticketSelectDiv.getBoundingClientRect().top
                var windowHeight = window.innerHeight;
                let ticketSelectDivHeight = windowHeight - ticketSelectDivTop;


                ticketSelectDiv.style.height = ticketSelectDivHeight + 'px';
                if(ticketFilter){
                    ticketFilter.style.height = ticketSelectDivHeight + 'px';
                }
            }

        },
        ticketDetailsScrollbar(){
            let self = this;
            setTimeout(() => {
                self.getEmailTicketDetailsListHeight ()
                let ticketReplyButton = document.querySelector('.ticket_mail_reply_button');
                let ticketReplyBox = document.querySelector('.ticket_mail_box_details');
                // let showTextArea = document.querySelector('.ticket_mail_reply_textarea');


                if(ticketReplyButton){
                    ticketReplyButton.addEventListener('click' , () => {
                        // showTextArea.classList.add('show');
                        ticketReplyBox.scrollTop = ticketReplyBox.scrollHeight;
                    })
                }


                // let deleteMailBtn = document.querySelector('.del_mail_form');
                // if(deleteMailBtn){
                //     deleteMailBtn.addEventListener('click' , () => {
                //         showTextArea.classList.remove('show');
                //     })
                // }
                /*let ticketSelectAllDiv = document.querySelector('.vlan_ticket_list_all_wrap');
                let collapseContact = document.querySelector('.collapse_contact');

                if(collapseContact){
                    collapseContact.addEventListener('click' , () => {
                        collapseContact.classList.toggle('active');
                        ticketSelectAllDiv.classList.toggle('collapse_contact_open')
                    })
                }*/
            }, 1000);
            window.addEventListener('resize', self.getEmailTicketDetailsListHeight);
        },
        chatComponentToggler(){
            let chatButton = document.querySelector('.chatbot_icon');
            let chatBox = document.querySelector('.chatbot_box_wrap');
            let closeChat = document.querySelector('.close_chat');


            chatButton.addEventListener('click', function() {
                chatBox.classList.toggle('open');
            });

            closeChat.addEventListener('click', function() {
                chatBox.classList.remove('open');
            });
        },
        navSwitch(event, listSelector = '.left_nav_list > li', finder = '.left_f_list', childSelector = '', childFinder = '') {
            let self = this;

            window.$(window.$(event.target).toggleClass('open'));

            var list = window.$(listSelector);
            var id = window.$(event.target).data('target');

            list.each(function(index, element) {
                var elementId = window.$(element).find(finder).data('target');

                if (id === elementId) {
                    if (window.$(id).is(":visible")) {
                        window.$(id).slideUp();
                    } else {
                        window.$(id).slideDown();
                    }
                } else {
                    window.$(element).find('.left_f_list').removeClass('open');
                    window.$(element).find('.left_f_list_level2').removeClass('open');
                    window.$(element).find('.left_f_list_level3').removeClass('open');
                    window.$(elementId).slideUp();

                    if (childSelector && childFinder) {
                        self.hideOtherNav(childSelector, childFinder);
                    }
                }
            });
        },
        hideOtherNav(selector = '.left_nav_list > li', finderSelector = '.left_f_list') {
            var list = window.$(selector);
            list.each(function(index, element) {
                var finder = window.$(element).find(finderSelector);
                var elementId = finder.data('target');
                finder.removeClass('open');
                window.$(elementId).slideUp();
            });
        },
        showHideNav(event, listSelector = '.left_nav_list > li', parentFinder = '[data-toggle="accordion"]', innerFinder = '.left_f_list') {
            let $selector = window.$(event.target);
            let $parentFinder = $selector.closest(parentFinder);
            $parentFinder.toggleClass('open');

            let targetId = $parentFinder.data('target');
            let $list = window.$(listSelector);

            $list.each((index, element) => {
                let $element = window.$(element);
                let elementId = $element.find(innerFinder).data('target');
                let $targetElement = window.$(targetId);

                if (targetId === elementId) {
                    $targetElement.stop(true, true).slideDown();

                    let elementOffset = $targetElement.offset() ? $targetElement.offset().top : 0;
                    let elementHeight = $targetElement.outerHeight();
                    let viewportHeight = window.$(window).height();
                    let computedHeight = elementHeight / 3;
                    let totalOffset = elementOffset + elementHeight;

                    if (totalOffset > viewportHeight) {
                        $targetElement.css({
                            'top': 'auto',
                            'bottom': -computedHeight,
                        });
                    }
                } else {
                    window.$(elementId).slideUp();
                }
            });
        },
        sidebarOnHover() {
            let self = this;

            // Attach hover events to the specified elements
            window.$('.left_menu_collapse [data-toggle="accordion"], .left_nav_list > li > .sub_accordion')
                .hover(
                    function () {
                        // On hover, call showHideNav to reveal the navigation
                        if (window.$(".left_menu_collapse").length > 0) {
                            self.showHideNav(this, '.left_nav_list > li', '[data-toggle="accordion"]', '.left_f_list');
                        }
                    },
                    function () {
                        // On hover out, call hideOtherNav to hide all visible elements
                        if (window.$(".left_menu_collapse").length > 0) {
                            self.hideOtherNav('.left_nav_list > li', '.left_f_list');
                            self.hideOtherNav('.left_nav_level2', '.left_f_list_level2');
                            self.hideOtherNav('.left_nav_level3', '.left_f_list_level3');
                        }
                    }
                );
        },
    }
}